"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventService = void 0;
var rxjs_1 = require("rxjs");
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var angular_utils_1 = require("../util/angular/angular-utils");
// tslint:disable:unified-signatures
var EventService = /** @class */ (function () {
    function EventService() {
        this.subject = new rxjs_1.Subject();
        this.replaySubject = new rxjs_1.ReplaySubject(1);
    }
    EventService.prototype.dispatch = function (eventName) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        this.subject.next({ name: eventName, data: data });
        this.replaySubject.next({ name: eventName, data: data });
    };
    EventService.prototype.subscribe = function (eventName, callback, getLast) {
        if (getLast === void 0) { getLast = false; }
        var subject = getLast ? this.replaySubject : this.subject;
        var subscription = subject.subscribe({
            next: function (event) {
                if (event.name === eventName) {
                    callback.apply(void 0, __spreadArray([eventName], __read(event.data)));
                }
            },
        });
        return function () {
            subscription.unsubscribe();
        };
    };
    EventService.prototype.subscribeNG = function (name, listener) {
        try {
            var $rootScope = angular_utils_1.getInjector().get('$rootScope');
            return $rootScope.$on(name, listener);
        }
        catch (error) {
            console.error('Failed to register event on $rootScope', error);
        }
        return function () {
            console.warn('');
        };
    };
    EventService = __decorate([
        CommonService_decorator_1.CommonService('EventService', { replaceAngularService: '$rootScope' })
    ], EventService);
    return EventService;
}());
exports.EventService = EventService;
//# sourceMappingURL=Event.service.js.map